// extracted by mini-css-extract-plugin
export default {"close":"details-top-buttons_close__zGt0T","back":"details-top-buttons_back__Miy5W"};